import { haptic } from "@/lib/haptic";

/**
 * Semantic haptic vocabulary for the app outside chat (chat has its own in
 * `chat-haptics`). Components call these by interaction name so the
 * intensity for each lives in one file. Keep them slight: a tick that
 * confirms a touch landed, never a buzz.
 */
export const uiHaptics = {
  /** A discrete choice moved: tab, tab-bar item, segmented control, switch. */
  select: () => haptic("selection"),
  /** Liked / reacted (posts, comments, stories). */
  like: () => haptic("light"),
  /** A long-press opened something (likes sheet, story pause). */
  longPress: () => haptic("medium"),
  /** Pull-to-refresh crossed its trigger line. */
  refreshArmed: () => haptic("light"),
  /** Something the viewer did went through: request sent, payment, scan. */
  success: () => haptic("success"),
  /** Went through, but with a caveat (already checked in, …). */
  warning: () => haptic("warning"),
  /** It failed. */
  error: () => haptic("error"),
  /** Small confirmations: copied, undone, toggled media sound. */
  tap: () => haptic("light"),
} as const;
